export const staticIcons = [
  {
    id: 1,
    subject: "English",
    img: "./assets/subject-logo/english.png",
  },
  {
    id: 2,
    subject: "Science",
    img: "./assets/subject-logo/science.png",
  },
  {
    id: 3,
    subject: "Hindi",
    img: "./assets/subject-logo/hindi.png",
  },
  {
    id: 4,
    subject: "Maths",
    img: "./assets/subject-logo/maths.png",
  },
  {
    id: 5,
    subject: "social science",
    img: "./assets/subject-logo/sst.png",
  },
  {
    id: 6,
    subject: "computer science",
    img: "./assets/subject-logo/computerscience.png",
  },
  {
    id: 7,
    subject: "sanskrit",
    img: "./assets/subject-logo/sanskrit.png",
  },
  {
    id: 8,
    subject: "physical education",
    img: "./assets/subject-logo/physicaleducation.png",
  },
  {
    id: 9,
    subject: "information technology",
    img: "./assets/subject-logo/IT.png",
  },
  {
    id: 10,
    subject: "philosophy",
    img: "./assets/subject-logo/philosophy.png",
  },
  {
    id: 11,
    subject: "political science",
    img: "./assets/subject-logo/politicalscience.png",
  },
  {
    id: 12,
    subject: "geography",
    img: "./assets/subject-logo/geography.png",
  },
  {
    id: 13,
    subject: "pyschology",
    img: "./assets/subject-logo/psychology.png",
  },
  {
    id: 14,
    subject: "sociology",
    img: "./assets/subject-logo/socialogy.png",
  },
  {
    id: 15,
    subject: "physics",
    img: "./assets/subject-logo/phyciscs.png",
  },
  {
    id: 16,
    subject: "entrepreneurship",
    img: "./assets/subject-logo/entreneur.png",
  },
  {
    id: 17,
    subject: "engineering graphics",
    img: "./assets/subject-logo/engggraphics.png",
  },
  {
    id: 18,
    subject: "biotechnology",
    img: "./assets/subject-logo/biotech.png",
  },
  {
    id: 19,
    subject: "economics",
    img: "./assets/subject-logo/economics.png",
  },
  {
    id: 20,
    subject: "business studies",
    img: "./assets/subject-logo/bussStudies.png",
  },
  {
    id: 21,
    subject: "social studies",
    img: "./assets/subject-logo/25.png",
  },
  {
    id: 22,
    subject: "accountancy",
    img: "./assets/subject-logo/accountancy.png",
  },
  {
    id: 23,
    subject: "home science",
    img: "./assets/subject-logo/homeScience.png",
  },
  {
    id: 24,
    subject: "english literature",
    img: "./assets/subject-logo/english.png",
  },
  {
    id: 25,
    subject: "history",
    img: "./assets/subject-logo/history.png",
  },
    {
    id: 26,
    subject: "python",
    img: "./assets/subject-logo/python.png",
  },
      {
    id: 27,
    subject: "java",
    img: "./assets/subject-logo/java.png",
  },
        {
    id: 28,
    subject: "javaScript",
    img: "./assets/subject-logo/js.png",
  },
          {
    id: 29,
    subject: "c#",
    img: "./assets/subject-logo/csharp.png",
  },
            {
    id: 30,
    subject: "c++",
    img: "./assets/subject-logo/cplus.png",
  },
              {
    id: 31,
    subject: "c",
    img: "./assets/subject-logo/c.png",
  },
];